import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { GetUser } from "store/slices/authSlice";
import { ActivePlanApi, EmptySmsAlertApi, FeatureAccessApi, MailChimpSubscriptionApi } from "store/slices/salonSlice";
import { usermoduleListViewApi, usermoduleAccessViewApi } from "../store/slices/usermoduleSlice";
import { OpenAddClientForm } from "../store/slices/clientSlice";
import { notificationCountApi } from "store/slices/notificationSlice";
import { OpenSmsRunOutAlerts } from "store/slices/calendarSlice";
import { useAuth } from "context/authContext";

const SalonModule = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { getAuthUser } = useAuth();
  const usermodule = useSelector((state) => state.usermodule.isListView);
  const auth = useSelector((state) => state.auth);
  const currentUser = auth && auth.user;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAuthUser = async () => {
      try {
        const userData = await getAuthUser();
        if (userData) {
          dispatch({
            type: "auth/user",
            payload: {
              ...auth,
              user: {
                ...auth.user,
                ...userData,
              },
            },
          });
        }
      } catch (error) {
        console.error("Error fetching auth user:", error);
      }
    };
    fetchAuthUser();
  }, []);

  if (currentUser && currentUser.role_id == 8 && ["/dashboard", "/staff", "/reports"].includes(location && location.pathname)) {
    navigate("/noaccess");
  }

  useEffect(() => {
    if (usermodule.length === 0) {
      dispatch(usermoduleListViewApi()).then((action) => {
        if (action.meta.requestStatus === "fulfilled") {
          //dispatch(salonpermission({ module_id: 6, permissonName: "list" }));
        }
      });
      dispatch(usermoduleListViewApi({ type: "staff_access" }));
    }
    if (currentUser && currentUser.isOwner === 1) {
      dispatch(notificationCountApi());
    } else {
      dispatch(notificationCountApi());
    }
  }, [location, usermodule.length]);

  useEffect(() => {
    dispatch(OpenAddClientForm(""));
    dispatch(MailChimpSubscriptionApi({ id:currentUser && currentUser.salon && currentUser.salon.id ? currentUser.salon.id : "", salon_id:currentUser && currentUser.salon && currentUser.salon.id }));
  }, [location]);

  useEffect(() => {
    if (!currentUser?.salon?.id || currentUser.salon.is_empty_sms_alert != 1) {
      return undefined;
    }

    const minutesRaw = currentUser?.sms_runout_reminder_minutes;
    const minutesParsed = parseInt(minutesRaw, 10);
    const minutes =
      Number.isFinite(minutesParsed) && minutesParsed >= 1 && minutesParsed <= 1440 ? minutesParsed : 15;
    const smsRunoutReminderMs = minutes * 60 * 1000;

    dispatch(OpenSmsRunOutAlerts("open"));

    const intervalId = setInterval(() => {
      dispatch(GetUser()).then((action) => {
        if (action.meta.requestStatus !== "fulfilled" || !action.payload) {
          return;
        }
        const user = action.payload;
        if (user?.salon?.is_empty_sms_alert == 1) {
          dispatch(OpenSmsRunOutAlerts("open"));
        } else {
          dispatch(OpenSmsRunOutAlerts(""));
        }
      });
    }, smsRunoutReminderMs);

    return () => clearInterval(intervalId);
  }, [dispatch, currentUser?.salon?.id, currentUser?.salon?.is_empty_sms_alert, currentUser?.sms_runout_reminder_minutes]);

  useEffect(() => {
    if (!currentUser?.salon) {
      return;
    }
    if (currentUser.salon.is_empty_sms_alert != 1) {
      dispatch(OpenSmsRunOutAlerts(""));
    }
  }, [dispatch, currentUser?.salon?.id, currentUser?.salon?.is_empty_sms_alert]);
};

export { SalonModule };
